import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AdminManagement from '@views/Admin/Management';

const messages = defineMessages({
  title: {
    id: 'admin.accounts.title',
    defaultMessage: 'Manage Accounts',
  },
});

function AdminAccountsPage() {
  const { formatMessage } = useIntl();

  return (
    <AdminManagement.Layout title={formatMessage(messages.title)}>
      <AdminManagement.Accounts.List />
    </AdminManagement.Layout>
  );
}

export default AdminAccountsPage;
